import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=a354c18e&scoped=true"
import script from "./Notes.vue?vue&type=script&lang=js"
export * from "./Notes.vue?vue&type=script&lang=js"
import style0 from "./Notes.vue?vue&type=style&index=0&id=a354c18e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a354c18e",
  null
  
)

export default component.exports